import _get from 'lodash/get';

import FLAG_SG from 'public/images/flag-singapore.svg';
import FLAG_ID from 'public/images/flag-indonesia.svg';
import FLAG_TH from 'public/images/flag-thailand.svg';
import FLAG_VN from 'public/images/flag-vietnam.svg';
import FLAG_MY from 'public/images/flag-malaysia.svg';
import FLAG_PH from 'public/images/flag-philippines.svg';
import FLAG_KH from 'public/images/flag-cambodia.svg';

import { STORAGE_LOCALE, STORAGE_USER_COUNTRY } from 'constants/app-constants';

export const APP_LANGUAGES = {
  en: 'en',
  id: 'id',
  ms: 'ms',
  th: 'th',
  vi: 'vi',
};

export const COUNTRY_FLAGS_CIRCLE = {
  SG: FLAG_SG,
  MY: FLAG_MY,
  ID: FLAG_ID,
  PH: FLAG_PH,
  TH: FLAG_TH,
  VN: FLAG_VN,
  KH: FLAG_KH,
};

export const SUPPORTED_COUNTRIES = [
  {
    code: 'SG',
    languages: [APP_LANGUAGES.en],
  },
  {
    code: 'MY',
    languages: [APP_LANGUAGES.ms, APP_LANGUAGES.en],
  },
  {
    code: 'PH',
    languages: [APP_LANGUAGES.en],
  },
  {
    code: 'ID',
    languages: [APP_LANGUAGES.id, APP_LANGUAGES.en],
  },
  {
    code: 'TH',
    languages: [APP_LANGUAGES.th, APP_LANGUAGES.en],
  },
  {
    code: 'VN',
    languages: [APP_LANGUAGES.vi, APP_LANGUAGES.en],
  },
  {
    code: 'KH',
    languages: [APP_LANGUAGES.en],
  },
];

export const getLocalesByCountryCode = countryCode =>
  _get(SUPPORTED_COUNTRIES.find(p => p.code === countryCode), 'languages', []);

export const getSelectedLocale = () => {
  const locale = window.localStorage.getItem(STORAGE_LOCALE) || 'en';
  return locale.toLowerCase();
};

export const setSelectedLocale = value => {
  window.localStorage.setItem(STORAGE_LOCALE, value);
};

export const getSelectedCountry = () => {
  const country = window.localStorage.getItem(STORAGE_USER_COUNTRY) || 'SG';
  return country.toUpperCase();
};

export const setSelectedCountry = value => {
  window.localStorage.setItem(STORAGE_USER_COUNTRY, value);
};

export default {};
